import { useStoredUser } from "./storage.mjs";
import { IdentityDocument } from "../../graphql/Auth.mjs";
import { useChannels, topics } from "../channels.mjs";
import { useQuery } from "villus";
export function useIdentity() {
  const { push } = useChannels();
  const { setUser } = useStoredUser();
  const { execute, isFetching: isFetchingIdentity } = useQuery({
    query: IdentityDocument.toString(),
    cachePolicy: "network-only",
    fetchOnMount: false
  });
  async function identify() {
    try {
      const { data, error } = await execute();
      if (error) {
        throw new Error(error.message);
      }
      setUser(data?.customer ?? void 0);
      push(topics.auth.identify, data?.customer);
      return data?.customer;
    } catch (err) {
      if (/The current customer isn't authorized/.test(err?.message)) {
        return;
      }
      console.log(err);
    }
  }
  return {
    identify,
    isFetchingIdentity,
    refetch: execute
  };
}
